import {all, takeLatest} from '@redux-saga/core/effects';
import {loginTypes} from '..';
import {logoutSaga} from './logout';

export function* loginSagas() {
   yield all([takeLatest(loginTypes.LOGOUT.SAGA, logoutSaga)]);
   // yield all([takeLatest(loginTypes.LOGIN.SUCCESS, loginActions.fetchRoles)]);
}
